import { IAction } from "@/interface/IAction";

export const actionType = Object.freeze({
    SET_USER_PRINCIPAL: 'user.set-user-principal',
    GET_USER_PRINCIPAL: 'user.get-user-principal',
    ACCEPT_FUNDER_APPLICANT: 'user.funder-applicant-accept',
    UPDATE_LANGUAGE: 'user.update-language',
});

export function setUserPrincipal(profile): IAction {
    return {
        type: actionType.SET_USER_PRINCIPAL,
        payload: { profile }
    }
}

export function getUserPrincipal(): IAction {
    return { type: actionType.GET_USER_PRINCIPAL, payload: {} }
}

export function updateLanguage(lang: string): IAction {
    return {
        type: actionType.UPDATE_LANGUAGE,
        payload: lang
    }
}